import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';
import { useNavigate, useParams } from 'react-router-dom';
import { SettingsMasterContext } from 'widgets/settings-master/model/context/type';
import { ButtonCard } from 'entities/settings-master/ui/card';
import { SettingsMasterStep, } from 'entities/settings-master/model/type';
import { cardSpec } from 'entities/settings-master/model/card-spec';
import { pathSpec } from 'entities/settings-master/model/path';
import { HintDialog } from 'entities/settings-master/ui/hints';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { CompareCards } from 'shared/components/compare-card';
import { useNavigateBack, useNavigateForward } from 'shared/hooks/router';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { SelectModelBoiler } from 'console/entities/settings-master/ui/select-model';
export function CompareView(props) {
    const { onClose } = props;
    const { boardId } = useParams();
    const { state } = useLocation();
    const boardCardsId = parseInt(boardId ?? '0');
    const navigate = useNavigate();
    const { path, progress, hint_key, typeDeviceForMasterSettings, closeHintDialog, onSave, dataSelectSettings, setDataSelectSettings, setPath, setProgress, getHintTitle, setHintKey, } = useContext(SettingsMasterContext);
    const onClickNextStepSetting = useCallback((card) => {
        const new_path = state?.path ? [...state.path, card.name] : [card.name];
        navigate(`/master-settings/list/${card.child_id(new_path)}`, {
            state: {
                progress: card.percent,
                path: new_path,
                hint: getHintTitle(card.name, new_path),
                dataSelect: { ...state?.dataSelect },
            },
        });
    }, []);
    const [state_send, , sendState] = useBooleanState(false);
    useEffect(() => {
        if (state && !state_send) {
            setPath(state.path);
            setProgress(state.progress);
            setHintKey(state.hint);
            if (state.dataSelect.pzaControl) {
                setDataSelectSettings({
                    ...dataSelectSettings,
                    pzaControl: state.dataSelect.pzaControl,
                });
            }
            if (state.dataSelect.pza) {
                setDataSelectSettings({
                    ...dataSelectSettings,
                    pza: state.dataSelect.pza,
                });
            }
            if (state.dataSelect.airTempSensor) {
                setDataSelectSettings({
                    ...dataSelectSettings,
                    airTempSensor: state.dataSelect.airTempSensor,
                });
            }
            sendState();
        }
    }, [state]);
    const onClickCard = useCallback((card) => () => {
        if (card.parent_id ===
            Object.keys(pathSpec[typeDeviceForMasterSettings]).length) {
            if (card.name === 'SavedSetting') {
                onSave();
            }
            onClose();
        }
        else {
            onClickNextStepSetting(card);
        }
    }, [onSave, onClose, onClickNextStepSetting]);
    const handleBackStep = useNavigateBack();
    const handleForwardStep = useNavigateForward();
    const { child, title } = useMemo(() => pathSpec[typeDeviceForMasterSettings][boardCardsId], [boardCardsId]);
    const component = useCallback((card_name, index) => {
        const card = 
        //@ts-ignore we now card that get this
        cardSpec[typeDeviceForMasterSettings][card_name];
        return card_name === SettingsMasterStep.BoilerModel ? (_jsx(SelectModelBoiler, { nextBoard: onClickCard(card), setDataSelectSettings: setDataSelectSettings, dataSelectSettings: dataSelectSettings, typeDeviceForMasterSettings: typeDeviceForMasterSettings })) : (_jsx(ButtonCard, { card: card, nextBoard: onClickCard(card), path: path }, boardId + 'ButtonCardComponent' + index));
    }, [onClickCard, path]);
    return (_jsxs(ErrorBoundary, { children: [_jsx(CompareCards, { data: child(path), component: component, progress: progress, title: title, handleBackStep: handleBackStep, handleForwardStep: handleForwardStep, is_back_step_disabled: boardCardsId <= 1, is_forward_step_disabled: true }), _jsx(ErrorBoundary, { children: _jsx(HintDialog, { onClose: closeHintDialog, content_key: hint_key }) })] }));
}
